import { render, staticRenderFns } from "./GalleryOverlay.vue?vue&type=template&id=75d0b70a&scoped=true&"
import script from "./GalleryOverlay.vue?vue&type=script&lang=js&"
export * from "./GalleryOverlay.vue?vue&type=script&lang=js&"
import style0 from "./GalleryOverlay.vue?vue&type=style&index=0&id=75d0b70a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d0b70a",
  null
  
)

export default component.exports